<template>
  <div class="mai-item" :style="borderStyle">
    <div class="mai-item-container">
      <div class="item-header">
        <img :src="item.header">
      </div>
      <div class="item-right">
        <div class="mai-user">
          <div class="nickname-container">
            <div class="mai-nickname">
              {{item.nickname}}
              <i class="iconfont icon-nan2" v-if="item.sex==1"></i>
              <i class="iconfont icon-nv2" v-else></i>
            </div>
            <div>
              {{createTime}}前被
              <span class="seller">{{item.user?item.user.nickname:""}}</span>出卖
            </div>
          </div>
        </div>
        <div class="zym">{{item.motto}}</div>
        <div class="yinxiang">
          <span
            class="yx-item"
            :class="item.sex==1?'yx-nan': 'yx-nv'"
            v-for="(flag, index) in item.flags"
            :key="'flag_'+index"
          >{{flag}}</span>
        </div>
        <div class="pics-container">
          <div class="pics" v-if="item.pics && item.pics.length > 0">
            <img
              class="mai-pic"
              v-for="(pic, index) in item.pics"
              :key="'pic_'+index"
              :src="pic"
              :style="imgStyle(index)"
              @click="showImagePreview(index)"
            >
          </div>
        </div>
        <div class="item-footer">
          <div class="viewzan">
            <div class="item-footer-item" @click="zan">
              <i class="iconfont icon-dianzan"></i>
              <span>{{item.zan}}人</span>
            </div>
            <div class="item-footer-item" @click="cai">
              <i class="iconfont icon-diancai"></i>
              <span>{{item.cai}}人</span>
            </div>
            <div class="item-footer-item">
              <i class="iconfont icon-index-jijian"></i>
              <span>{{item.interest}}人</span>
            </div>
          </div>
          <div class="handle-bnt" @click="hu">
            <div :class="item.sex==1?'bnt-nan': 'bnt-nv'">呼TA</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import weui from "weui.js";

export default {
  props: {
    item: Object,
    openid: String
  },
  data() {
    return {
      borderStyle: "",
      createTime: null,
      picWidth: 0,
      initialIndex: 0
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let du = moment.duration(moment() - moment(this.item.createdAt), "ms");
    this.createTime = du.locale("zh-cn").humanize();

    if (this.item.sex == 0) {
      this.borderStyle =
        "border: 1px solid #ff9db3; border-radius: 10px; margin: 10px;";
    } else if (this.item.sex == 1) {
      this.borderStyle =
        "border: 1px solid #1296db; border-radius: 10px; margin: 10px;";
    }
  },
  methods: {
    imgStyle(index) {
      if (index == 2 || index == 5 || index == 8) {
        let style =
          "width:" +
          this.picWidth +
          "px; height:" +
          this.picWidth +
          "px; margin-right: 0px;";
        return style;
      } else {
        let style =
          "width:" + this.picWidth + "px; height:" + this.picWidth + "px;";
        return style;
      }
    },
    showImagePreview(index) {
      this.initialIndex = index;
      const params = {
        $props: {
          imgs: this.item.pics,
          initialIndex: "initialIndex", // 响应式数据的key名
          loop: false
        },
        $events: {
          change: i => {
            // 必须更新 initialIndex
            this.initialIndex = i;
          }
        }
      };
      this.$createImagePreview({ ...params }).show();
    },
    zan() {
      axios
        .put("/api/circle/active/" + this.item._id, {
          bizType: 20,
          type: 20,
          openid: this.openid
        })
        .then(res => {
          if (res.data.data == 0) {
            weui.toast("您已赞过", 500);
          } else {
            this.item.zan++;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    cai() {
      axios
        .put("/api/circle/active/" + this.item._id, {
          bizType: 20,
          type: 30,
          openid: this.openid
        })
        .then(res => {
          if (res.data.data == 0) {
            weui.toast("您已踩过", 500);
          } else {
            this.item.cai++;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    hu() {
      axios
        .put("/api/circle/active/" + this.item._id, {
          bizType: 20,
          type: 40,
          openid: this.openid
        })
        .then(res => {
          if (res.data.data == 0) {
            weui.toast("您已呼过TA", 500);
          } else {
            this.item.interest++;
            axios
              .get("/api/circle/hu/" + this.item._id)
              .then(huRes => {
                if (huRes.data.success) {
                  weui.alert(
                    'TA的联系方式已经通过"校圆通"公众号发给您，请注意查收'
                  );
                } else {
                  console.log("...");
                }
              })
              .catch(huErr => {
                console.log(huErr);
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.picWidth = parseInt((document.body.clientWidth - 112) / 3);
  }
};
</script>

<style scoped>
.mai-item {
  display: flex;
  border-bottom: 1px solid #bdccd4;
}
.mai-item-container {
  margin: 10px;
  display: flex;
  width: 100%;
}
.item-header {
  margin-right: 10px;
}
.item-header img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.item-right {
  flex: 1;
}
.mai-user {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #efefef;
}
.nickname-container {
  flex: 1;
  margin-bottom: 5px;
}
.mai-nickname {
  flex: 1;
  font-size: 16px;
}
.icon-nan2 {
  color: #1296db;
}
.icon-nv2 {
  color: #ff9db3;
}
.seller {
  color: red;
}
.mai-value {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.mai-value-label-nan {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #1296db;
  width: 30px;
  height: 30px;
  font-size: 14px;
  font-weight: bold;
}
.mai-value-label-nv {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #ff9db3;
  width: 30px;
  height: 30px;
  font-size: 14px;
  font-weight: bold;
}
.zym {
  font-size: 14px;
  margin-top: 5px;
}
.zym-flag {
  background-color: red;
  color: #ffffff;
  padding: 2px 4px;
  border-radius: 4px;
  margin-right: 5px;
}
.yinxiang {
  font-size: 14px;
  padding-bottom: 5px;
}
.yx-item {
  padding: 0px 8px;
  color: #ffffff;
  border-radius: 11px;
  margin-right: 5px;
  display: inline-block;
  margin-top: 8px;
  height: 22px;
}
.yx-nan {
  background-color: #1296db;
}
.yx-nv {
  background-color: #ff9db3;
}
.pics-container {
  border-bottom: 1px solid #efefef;
}
.pics {
  padding-bottom: 5px;
}
.pic-bottom {
  padding-bottom: 10px;
}
.mai-pic {
  object-fit: cover;
  display: inline-block;
  margin-top: 5px;
  margin-right: 5px;
}
.item-footer {
  display: flex;
  margin-top: 5px;
}
.viewzan {
  flex: 1;
  display: flex;
  align-items: center;
}
.item-footer-item span {
  font-size: 15px;
  margin-left: 2px;
}
.item-footer-item + .item-footer-item {
  margin-left: 5px;
}
.handle-bnt {
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22px;
}
.bnt-nan {
  background-color: #1296db;
  color: #ffffff;
  padding: 0px 10px;
  border-radius: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bnt-nv {
  background-color: #ff9db3;
  color: #ffffff;
  padding: 0px 10px;
  border-radius: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>





// WEBPACK FOOTER //
// src/components/common/MaiItem.vue